import Footer from '../../molecules/Footer';
import Header from '../../molecules/Header';
import { useHistory, useParams } from 'react-router-dom';
import { getMailStop } from '../../../container/templates/MailStopContainer';
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { SCREEN } from '@common/Common';
import { updateMailDeliveryStopResult } from '../../../container/templates/MailDeliveryStopContainer';
import { API_RESULT_CD } from '@common/external/Common';

export interface MailStopParams {
  id: string;
  token: string;
}

const ERROR_URL = '/error';
/**
 * メール配信設定 初期画面
 */
const MailDeliveryTop: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id, token } = useParams<MailStopParams>();
  const [isView, setView] = useState(false);

  useEffect(() => {
    const getMailStopResult = async () => {
      const mailStopResult = await getMailStop({ customerId: parseInt(id), token });

      let redirect = '';
      // 処理結果コードが正常"0000"以外の場合
      if (mailStopResult.result.resultCd !== API_RESULT_CD.OK) {
        const filterItem = mailStopResult.result.resultMessageDtoList?.filter((result) => result.resultMessageCd === 'I_020');

        // メンテナンスコードの場合
        if (filterItem && filterItem?.length > 0) {
          redirect = SCREEN.MAIL_SYS_MAINTE.URL;
        } else {
          redirect = ERROR_URL;
        }
      } else {
        // 顧客IDとトークンのヒット件数を確認する。
        const mailHit = mailStopResult.hit;
        if (!mailHit || mailHit < 1) {
          redirect = ERROR_URL;
        }
      }

      // エラーがあった場合、エラー画面へリダイレクトする。
      if (redirect) {
        history.push(redirect);
      } else {
        setView(true);
      }
    };
    getMailStopResult();
  }, []); // eslint-disable-line

  const unsubscribeHandler = async () => {
    const unsubscribeResult = await updateMailDeliveryStopResult({ customerId: parseInt(id), token }, dispatch);
    if (unsubscribeResult) {
      history.push(`${SCREEN.MAIL_STOP_DONE.URL}/${id}/${token}`);
    } else {
      history.push(ERROR_URL);
    }
  };

  return isView ? (
    <div>
      <Header />
      <div className='md-container'>
        <h2 className='md-headline' data-testid-e2e='mail-unsubscribe-text'>
          メールの配信を停止しますか？
        </h2>
        <p className='md-text' data-testid-e2e='mail-unsubscribe-detail-text'>
          店舗からのおトクな情報が配信されなくなります。
          <br />※ ご契約に関する情報など、重要なメールは配信停止されません。
          <br />
          停止処理には時間がかかる場合があります。
        </p>
        <button className='md-button md-button--primary' data-testid-e2e='mail-unsubscribe-button' onClick={unsubscribeHandler}>
          配信を停止する
        </button>
      </div>
      <Footer />
    </div>
  ) : (
    <></>
  );
};
export default MailDeliveryTop;
